/* eslint-disable */
import * as util from "@/api/aiKey";

const state = {
    language_style: [],
    aiBalance: null
    // {
    //     is_available: false,
    //     balance_infos: [
    //       {
    //         currency: "USD",
    //         total_balance: "0",
    //         granted_balance: "0.00",
    //         topped_up_balance: "0.00",
    //       },
    //     ],
    //   }
};


const mutations = {
    SET_LANGUAGE_STYLE(state, payload) {
        state.language_style = payload;
    },
    SET_BALANCE_DATA(state, payload) {
        state.aiBalance = payload
    }
};

const actions = {
    deleteKB({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.deleteKB(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    historyListKB({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.historyListKB(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    knowledgeBaseSummary({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.knowledgeBaseSummary(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    knowledgeBaseChunks({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.knowledgeBaseChunks(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    knowledgeBaseChunkDetail({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.knowledgeBaseChunkDetail(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    knowledgeBaseSearch({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.knowledgeBaseSearch(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    knowledgeBaseJobDetail({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.knowledgeBaseJobDetail(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    knowledgeBaseJobChunks({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.knowledgeBaseJobChunks(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    knowledgeBaseLatestJob({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.knowledgeBaseLatestJob(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    knowledgeBaseFileContent({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.knowledgeBaseFileContent(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    knowledgeBaseUpdateContent({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.updateKnowledgeBaseFileContent(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    knowledgeBaseRetryJob({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.retryKnowledgeBaseJob(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    createSchedule({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.createSchedule(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    regenerateSuggest({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.regenerateSuggest(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    registerTrial({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.registerTrial(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    sessionDestroy({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.sessionDestroy(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    sessionPause({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.sessionPause(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    sessionDelete({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.sessionDelete(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    sessionStart({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.sessionStart(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    summaryFollowup({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.summaryFollowup(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    summaryDelete({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.summaryDelete(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listSessions({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.listSessions(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listSummary({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.listSummary(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listSummaryExcel({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.listSummaryExcel(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listSessionsExcel({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.listSessionsExcel(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    setupKey({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.setupKey(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getDetail({ commit }) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.getDetail().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getAIKey({ commit }) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.getAIKey().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getBalance({ commit }) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.getBalance().then(response => {
                commit('SET_BALANCE_DATA', response.data);
                resolve(response);
            }).catch(error => {
                commit('SET_BALANCE_DATA', {
                    is_available: false,
                    balance_infos: [
                        {
                            currency: "USD",
                            total_balance: "0",
                            granted_balance: "0.00",
                            topped_up_balance: "0.00",
                        },
                    ],
                });
                reject(error);
            });
        });
    },
    getRecommendationText({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.getRecommendationText(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getLanguageStyle({ commit }) {
        if (state.language_style.length > 0) {
            return new Promise((resolve, reject) => {
                resolve({
                    data: state.language_style
                });
            });
        } else {
            return new Promise((resolve, reject) => {
                util.getLanguageStyle().then(response => {
                    commit('SET_LANGUAGE_STYLE', response.data);
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        }
    },
    listIntentWorkflowUser({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.listIntentWorkflowUser(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/aiKey.js